import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useMemo } from 'react';
// Define the initial state of the context
const initialValue = {
    environmentOptions: {
        apiKey: '',
        application: 'aap',
        environment: 'development',
    },
    globalRestrictTo: undefined,
};
// Create the context
export const SourSearchAppContext = createContext(initialValue);
// Create a provider component
export const SourSearchAppProvider = ({ children, environmentOptions, globalRestrictTo, onGlobalOnSeeAllClick }) => {
    const values = useMemo(() => ({
        environmentOptions,
        globalRestrictTo,
        onGlobalOnSeeAllClick,
    }), [globalRestrictTo, environmentOptions]);
    return _jsx(SourSearchAppContext.Provider, { value: values, children: children });
};
//# sourceMappingURL=app-context.js.map